import styled from 'styled-components';
import { Navbar } from 'react-bootstrap';


const StyledToggle = styled(Navbar.Toggle)`
  border: none !important;

  :focus, :hover {
    background-color: transparent !important;
  }

  .icon-bar{
    background-color: #888 !important;
    -webkit-transition: all 0.15s !important;
    transition: all 0.15s !important;
  }

  margin-top: 8px !important;
  margin-bottom: 8px !important;
`;

export default StyledToggle;



// WEBPACK FOOTER //
// ./src/components/shared/Nav/StyledToggle.js